export const BASE_URL = 'http://localhost:8000'
export const BASE_PATH = '/portal/app/#'
export const BASE_PATH_NEW_JOINER = '/portal/app/new-joiner/#'

export const EMPLOYEE_ADMIN_ID = 6

export const EVERPHONE_ORG_ID = 61
export const EVERPHONE_PRODUCT_OFFERS_ORG_ID = 174
export const EVERPHONE_EMPLOYEE_ID = 1

export const ERNST_YOUNG_ORG_ID = 163
export const NO_RENT_CATEGORY_ORG_ID = 165
export const RENTAL_PROLONGING_ORG_ID = 177
export const REASSIGN_DEVICE_ORG_ID = 169
export const ORDER_RENT_CATEGORIES_ORG_ID = 176

// smartphone | tablet | laptop | other
export const LIMITATION_RULES_EMPLOYEE_0000_ID = 91
export const LIMITATION_RULES_EMPLOYEE_1110_ID = 92
export const LIMITATION_RULES_EMPLOYEE_1111_ID = 93
export const LIMITATION_RULES_EMPLOYEE_1112_ID = 94

export const ADMIN_USERNAME = 'admin.user@everphone.de'
export const EMPLOYEE_USERNAME = 'everphone.employee1@everphone.de'
export const USER_PASSWORD = 'everphone2019!'

export const NEW_JOINER_USERNAME = 'nodeviceuser'
export const NEW_JOINER_PASSWORD = 'dummy-external-token'

export const E2E_TEST_ADDRESS = {
  attn: 'testAttn',
  city: 'testCity',
  country: 'United Kingdom',
  streetName: 'testStreetName',
  streetNumber: '987',
  to: 'testTo',
  zipcode: '65432',
}

export const EARLY_UPGRADE_BADGE = 'Upgrade possible'
export const UPGRADE_BADGE = 'New device'
